import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-content-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle-site"
}
const _hoisted_4 = { class: "second-step" }
const _hoisted_5 = {
  key: 0,
  class: "estimate-content-container estimate-form"
}
const _hoisted_6 = { class: "form-title" }
const _hoisted_7 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_EstimateForm = _resolveComponent("EstimateForm")!
  const _component_SelectSite = _resolveComponent("SelectSite")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('app.ask.estimate.title')) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "demandeDevis.definition" }),
        (_ctx.step === _ctx.EstimateFormStep.first)
          ? (_openBlock(), _createBlock(_component_ReglePastille, {
              key: 0,
              cle: "demandeDevis.siteObligatoire"
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_ReglePastille, {
              key: 1,
              cle: "demandeDevis.siteNonModifiable"
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.step === _ctx.EstimateFormStep.second)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_ctx.selectedSite?.description ?? ''), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.step === _ctx.EstimateFormStep.second)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('app.ask.estimate.form.title')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('app.ask.estimate.required')), 1),
              _createVNode(_component_EstimateForm)
            ]))
          : (_openBlock(), _createBlock(_component_SelectSite, {
              key: 1,
              selectedSite: _ctx.selectedSite,
              title: _ctx.$t('siteSelection.searchBar.title.estimate'),
              "regle-cle": "demandeDevis.listeSites",
              class: "estimate-content-container",
              onPick: _ctx.selectSite,
              onFilterChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectSite(undefined)))
            }, null, 8, ["selectedSite", "title", "onPick"]))
      ])
    ]),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirm: _ctx.sendEstimate,
      confirmButtonDisabled: !_ctx.formValid,
      first: _ctx.step === _ctx.EstimateFormStep.first,
      isEditing: _ctx.isEditing,
      last: _ctx.step === _ctx.EstimateFormStep.second,
      next: _ctx.next,
      "v-if": false
    }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "isEditing", "last", "next"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 0,
          text: _ctx.$t('estimate.request.pending')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 1,
          subtitle: _ctx.$t('estimate.success.subtitle'),
          title: _ctx.response,
          onClick: _ctx.cancel
        }, null, 8, ["subtitle", "title", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}